<template>
  <v-tab-item key="overview" value="overview">
    <v-row>
      <v-col>
        <div class="px-2 px-md-0">
          <h2
            class="title font-weight-bold pb-2 border-bottom border-thick border-primary"
          >
            Welcome to {{ community.name }}
          </h2>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="mr-2 mt-3" v-html="sanitizedLongDescription"></div>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="hasLatestContent">
      <v-col>
        <SelectedArticles
          title="Latest Content"
          :articles="latestContent"
          :show-content-type="showContentTypeCommunity"
        />
      </v-col>
    </v-row>

    <v-row v-if="hasLatestContent">
      <v-col>
        <div class="text-center">
          <v-btn outlined rounded @click="showContentTab">
            View More
            <span class="d-sr-only">&nbsp;{{ community.name }} content</span>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="showLatestCollections">
      <v-col>
        <div class="px-3 px-md-0">
          <h2
            class="title font-weight-bold pb-2 border-bottom border-thick border-primary"
          >
            Latest Collections
          </h2>
          <ContainerGrid>
            <LayoutItems
              :items="latestCollections"
              component-name="CollectionOverview"
              cols="12"
              sm="6"
              md="6"
              lg="4"
            />
          </ContainerGrid>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="showLatestCollections">
      <v-col>
        <div class="text-center">
          <v-btn outlined rounded @click="showCollectionsTab">
            View More
            <span class="d-sr-only"
              >&nbsp;{{ community.name }} collections</span
            >
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="hasRelatedEvents">
      <v-col>
        <div class="px-3 px-md-0">
          <h2
            class="title font-weight-bold pb-2 border-bottom border-thick border-primary"
          >
            Related Events
          </h2>
          <ContainerGrid>
            <LayoutItems
              :items="community.events"
              component-name="EventSummary"
              cols="12"
              sm="6"
              md="6"
              lg="4"
            />
          </ContainerGrid>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <div class="px-3 px-md-0">
          <h2
            class="title font-weight-bold pb-2 border-bottom border-thick border-primary"
          >
            Help Us Shape This Community
          </h2>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="mt-3 mr-2" v-html="sanitizedHelpDescription"></div>
        </div>
      </v-col>
    </v-row>
  </v-tab-item>
</template>

<script>
import mapFlags from "~/plugins/utilities/mapFlags";

import ContainerGrid from "~/components/layout/ContainerGrid";
import LayoutItems from "~/components/layout/LayoutItems";
import SelectedArticles from "~/components/articles/SelectedArticles.vue";

export default {
  name: "CommunityOverviewTab",
  components: {
    ContainerGrid,
    LayoutItems,
    SelectedArticles,
  },
  props: {
    community: { type: Object, default: () => {} },
    latestContent: { type: Array, default: () => [] },
    latestCollections: { type: Array, default: () => [] },
  },
  computed: {
    ...mapFlags(["showContentTypeCommunity", "showCollections"]),
    partner() {
      return this.$config.partner;
    },
    communityContentTabUrl() {
      return `/engage/${this.partner}/community-details/${this.community.id}?show=content`;
    },
    communityCollectionsTabUrl() {
      return `/engage/${this.partner}/community-details/${this.community.id}?show=collections`;
    },
    sanitizedLongDescription() {
      return this.sanitizeDescription(this.community.longDescription);
    },
    sanitizedHelpDescription() {
      return this.sanitizeDescription(this.community.helpDescription);
    },
    hasLatestContent() {
      return !!this.latestContent?.length;
    },
    hasRelatedEvents() {
      return !!this.community.events?.length;
    },
    showLatestCollections() {
      return this.showCollections && !!this.latestCollections?.length;
    },
  },
  methods: {
    sanitizeDescription(description) {
      return this.$sanitize(description, {
        allowedAttributes: {
          a: ["href", "target"],
          "*": ["aria-*", "role", "style", "class"],
        },
      });
    },
    showContentTab() {
      this.$router.push({ path: this.communityContentTabUrl });
      this.$vuetify.goTo(0);
    },
    showCollectionsTab() {
      this.$router.push({ path: this.communityCollectionsTabUrl });
      this.$vuetify.goTo(0);
    },
  },
};
</script>
